export namespace ImageCdn {
  const imagePathPattern = /^\/v1\/images\/[^/]+$/
  const defaultQuality = 75

  export interface TransformOptions {
    width: number
    quality?: number
  }

  const parse = (url: string): URL | null => {
    try {
      return new URL(url)
    } catch {
      return null
    }
  }

  export const src = (url: string, options: TransformOptions): string => {
    const parsed = parse(url)

    if (parsed === null || !imagePathPattern.test(parsed.pathname)) {
      return url
    }

    parsed.searchParams.set("w", String(options.width))
    parsed.searchParams.set("q", String(options.quality ?? defaultQuality))
    parsed.searchParams.set("f", "auto")
    parsed.searchParams.set("fit", "scale-down")

    return parsed.toString()
  }

  export const srcSet = (url: string, options: TransformOptions): string => {
    const at1x = src(url, options)
    const at2x = src(url, { ...options, width: options.width * 2 })

    return `${at1x} 1x, ${at2x} 2x`
  }
}
